import { AfterViewInit, Component, OnInit } from "@angular/core";

@Component({
  selector: "wave-effect",
  template: `<sk-wave></sk-wave>`,
  styleUrls: [],
})
export class WaveEffect {}



// WEBPACK FOOTER //
// ./src/app/UI/wave-effect.ts